import { render, staticRenderFns } from "./ArgsPopup.vue?vue&type=template&id=63af7cee&scoped=true&"
import script from "./ArgsPopup.vue?vue&type=script&lang=js&"
export * from "./ArgsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ArgsPopup.vue?vue&type=style&index=0&id=63af7cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af7cee",
  null
  
)

export default component.exports